import { render, staticRenderFns } from "./deptRetreat.vue?vue&type=template&id=cf331478"
import script from "./deptRetreat.vue?vue&type=script&lang=js"
export * from "./deptRetreat.vue?vue&type=script&lang=js"
import style0 from "./deptRetreat.vue?vue&type=style&index=0&id=cf331478&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports